/* @flow */
import React, { PropTypes } from 'react';

import FaqItem from './faq-item';

class FaqGroup extends React.Component {

  static propTypes = {
    id: PropTypes.number,
    isActive: PropTypes.bool,
    toggle: PropTypes.func,
    title: PropTypes.string,
    questionGroup: PropTypes.array,
    toggleFaqItem: PropTypes.func,
    addFaqItemRef: PropTypes.func
  };

  constructor (props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick () {
    this.props.toggle(this.props.id);
  }

  render () {
    return (
      <dl>
        <dt className={this.props.isActive ? 'open' : null} onClick={this.handleClick}>
          <a>{this.props.title}</a>
        </dt>
        <dd>
          <dl className="accordion">
            {this.props.questionGroup.map((question) => {
              if (question.q) {
                return (
                  <FaqItem
                    key={question.id}
                    {...question}
                    toggle={this.props.toggleFaqItem}
                    addRef={this.props.addFaqItemRef}
                  />
                );
              }
            })}
          </dl>
        </dd>
      </dl>
    );
  }
}

export default FaqGroup;



/** WEBPACK FOOTER **
 ** ./src/views/faq/faq-group.js
 **/